import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import { BILLING_CONFIG } from "./apiRoutes";
import axiosAuth from "@/services/axiosAuth";

const mutateAddBillingConfig = async ({ data }: { data: FieldValues }) => {
  return await axiosAuth.post(`${BILLING_CONFIG(data?.communityId)}/`, data);
};

const useAddBillingConfigMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateAddBillingConfig,
    ...queryParams,
  });

export default useAddBillingConfigMutation;
